import * as yup from 'yup';
import { ObjectShape } from 'yup/lib/object';
import { checkDateIsStrictlyLower } from 'utils/date';

export const expeditionClientReport = (
  t: (key: string, options?: { [key: string]: string }) => string,
): ObjectShape => {
  return {
    startDate: yup
      .date()
      .typeError(t('client.validation.startDate.invalid'))
      .nullable()
      .required(t('client.validation.startDate.required'))
      .when('endDate', {
        is: (endDate: Date | null) => !!endDate,
        then: yup
          .date()
          .typeError(t('client.validation.startDate.invalid'))
          .nullable()
          .required(t('client.validation.startDate.required'))
          .test('startDateValidation', t('client.validation.startDate.greaterThanEndDate'), (value, context) => {
            const endDate = context.parent.endDate;
            return checkDateIsStrictlyLower(value, endDate);
          }),
      }),
    endDate: yup
      .date()
      .typeError(t('client.validation.startDate.invalid'))
      .nullable()
      .required(t('client.validation.endDate.required'))
      .test('endDateValidation', t('client.validation.endDate.lesserThanStartDate'), (value, context) => {
        const startDate = context.parent.startDate;
        return !startDate || '' === startDate || checkDateIsStrictlyLower(startDate, value);
      }),
  };
};
